import { useState, useEffect, useRef } from "react";
import { T } from "../../styles/GlobalStyles";
import { pickDailyPhrase } from "../../utils/pickDailyPhrase";

const prefersReducedMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function PageTagline({ phrases, hideDot, pageId }) {
  const [phrase] = useState(() => pickDailyPhrase(phrases, pageId));
  const [showDot, setShowDot] = useState(false);
  const [displayed, setDisplayed] = useState("");
  const rafRef = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion) {
      setShowDot(true);
      setDisplayed(phrase);
      return;
    }

    const dotTimer = setTimeout(() => setShowDot(true), 300);
    const startTyping = setTimeout(() => {
      let i = 0;
      const tick = () => {
        i++;
        setDisplayed(phrase.slice(0, i));
        if (i < phrase.length) {
          const delay = phrase[i] === " " ? 20 : 25 + Math.random() * 20;
          rafRef.current = setTimeout(tick, delay);
        }
      };
      tick();
    }, 700);

    return () => {
      clearTimeout(dotTimer);
      clearTimeout(startTyping);
      if (rafRef.current) clearTimeout(rafRef.current);
    };
  }, [phrase]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: hideDot ? 0 : 8,
        marginTop: 10,
        minHeight: 20,
      }}
    >
      {!hideDot && (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 18,
            height: 18,
            borderRadius: "50%",
            background: T.accent,
            color: T.bg,
            fontSize: 10,
            fontWeight: 700,
            fontStyle: "normal",
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: 0,
            flexShrink: 0,
            opacity: showDot ? 1 : 0,
            transform: showDot ? "scale(1)" : "scale(0.5)",
            transition: "opacity 250ms ease-out, transform 250ms ease-out",
            animation:
              showDot && !prefersReducedMotion
                ? "athleosPulse 2.5s ease-in-out infinite"
                : "none",
          }}
        >
          A
        </span>
      )}
      <span
        style={{
          fontSize: 13,
          fontStyle: "italic",
          color: T.muted,
          fontWeight: 400,
          fontFamily: "'DM Sans', sans-serif",
          letterSpacing: 0,
          textTransform: "none",
          whiteSpace: "pre",
        }}
      >
        {displayed}
        {displayed.length > 0 && displayed.length < phrase.length && (
          <span
            style={{
              display: "inline-block",
              width: 1,
              height: 14,
              background: T.muted,
              marginLeft: 1,
              verticalAlign: "text-bottom",
              animation: "cursorBlink 600ms steps(2) infinite",
            }}
          />
        )}
      </span>
      <style>{`
        @keyframes athleosPulse{0%,100%{box-shadow:0 0 0 0 ${T.accent}59}50%{box-shadow:0 0 0 8px ${T.accent}00}}
        @keyframes cursorBlink{0%{opacity:1}100%{opacity:0}}
      `}</style>
    </div>
  );
}
